import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="px-6 py-24 max-w-md mx-auto animate-in fade-in duration-500" data-testid="login-page">
      <p className="overline text-primary mb-4">Account</p>
      <h1 className="editorial-heading text-4xl md:text-5xl text-secondary mb-3">Sign in</h1>
      <p className="text-muted-foreground mb-10 text-sm">
        Track your orders and access your Certificates of Analysis.
      </p>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="rounded-none mt-1.5" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="rounded-none mt-1.5" />
        </div>
        <Button
          type="submit"
          disabled={submitting}
          data-testid="login-submit"
          className="w-full rounded-none bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground uppercase tracking-[0.22em] text-xs py-6"
        >
          {submitting ? "..." : "Sign in"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-8 text-center">
        New here?{" "}
        <Link to="/register" className="text-secondary underline underline-offset-4 hover:text-primary" data-testid="login-to-register">
          Create an account
        </Link>
      </p>
    </div>
  );
}
